<template>
  <el-container>
    <el-header>
      <el-row>
        <el-col :span="8"><div class="grid-content bg-purple-dark logo-right">  <img v-if="logo" :src="logo" ></div></el-col>
        <el-col :span="16"><div class="grid-content bg-purple-dark">
          <el-menu
            class="el-menu-demo"
            mode="horizontal"
            background-color="#fff"
            text-color="#545c64"
            active-text-color="#2A53A2"
            :default-active="this.$router.path"
            router
          >

            <el-menu-item index="/">主页</el-menu-item>
            <el-menu-item index="/introduction">公司简介</el-menu-item>
            <el-menu-item index="/solution">解决方案</el-menu-item>
            <el-menu-item index="/product">产品展示</el-menu-item>
            <el-menu-item index="/info">媒体报道</el-menu-item>
            <el-menu-item index="/about">联系我们</el-menu-item>
          </el-menu>

        </div></el-col>
      </el-row>

    </el-header>
    <el-main>
      <el-carousel :interval="4000"   arrow="always" height="300px">
        <el-carousel-item v-for="(item,index) in urls" :key="index">
          <el-image :src="item.thumb"></el-image>
        </el-carousel-item>
      </el-carousel>
      <div class="main-view">
        <router-view/>
      </div>
    </el-main>
    <el-footer>
        <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark footer-center">
           <div>Copyright &copy; 2020.{{title}} All rights reserved </div>
            <div> <a href="https://beian.miit.gov.cn/" style="color: #FFFFFF;">皖ICP备20002854号-1</a> <a href="https://beian.miit.gov.cn/"  style="color: #FFFFFF;">皖ICP备20002854号-2</a></div>
        </div></el-col>
        </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import Logo from '@/assets/logo.png'
export default {
  name: 'Index',
  data () {
    return {
      title: '友辰科技',
      logo: Logo,
      urls: []
    }
  },
  created () {
    const self = this
    this.$axios.get('/cms/getcolumn/4')
      .then(function (res) {
        self.urls = res.data.data
        console.log(res)
      })
      .catch(res => {
      })
  }
}
</script>

<style scoped>
  .el-menu-item {
    padding-left: 20px;
    font-weight: bold;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding-right: 20px;
    height: 120px !important;
    font-size:20px;
    line-height: 120px !important;
  }
  .logo-right{
    float: right;
  }
  .footer-center{
    font-size:1.2em;
    background: #5E5E5E;
    color: #e5e9f2;
    text-align: center ;
    padding: 40px;
    line-height: 40px;
    height: 80px;
    border-radius: 10px;
  }
  .el-main{
    margin-top: 60px;
  }
  .main-view
  {
    margin-top: 10px;
  }
  .el-image{
    border-radius: 10px;
    height: 290px;
    text-align: center;
  }

</style>
